/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat, Gianni Guida.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import Navigation from 'flarum/common/components/Navigation';

export default function () {
	extend(Navigation.prototype, ['oncreate', 'onupdate'], function () {
		// Check if the mobile header title is already present in the DOM
		if (!$('#app-navigation .Header-title-mobile').length) {
			// Get the Header-title from the DOM
			const $headerTitle = $('.App-header .container div.Header-title');
			if ($headerTitle.length) {
				// Append the Header-title to the #app-navigation element
				const $mobileHeaderTitle = $('<div class="Header-title Header-title-mobile"></div>');
				$('#app-navigation').append($mobileHeaderTitle);

				m.mount($mobileHeaderTitle[0], {
					view: () =>
						Link.component(
							{
								id: 'mobile-home-link',
								href: $('#home-link').attr('href'),
								onclick: (e) => {
									// code of this callback is copy pasted from flarum/core/js/src/forum/ForumApplication.js

									if (e.ctrlKey || e.metaKey || e.which === 2) return;
									e.preventDefault();
									e.stopPropagation();
									app.history.home();

									// Reload the current user so that their unread notification count is refreshed.
									if (app.session.user) {
										app.store.find('users', app.session.user.id());
										m.redraw();
									}
								},
							},
							// write this using jquery (headerTitle has a <a> child and we want to get the innerHTML of that child)
							m.trust($headerTitle.find('a').html())
						),
				});
			}
		}
	});
}
